export enum TripType {
    ONE_WAY = 'ONE_WAY',
    ROUND_TRIP = 'ROUND_TRIP',
    MULTI_CITY = 'MULTI_CITY'
  }
